import React from 'react';
import '../../components/css/popupstyle.css';
import { userService } from '../../_services';
import $ from 'jquery';
import DeleteIcon from '../.././components/css/dark/img/delete.svg';
import EditIcon from '../.././components/css/dark/img/edit2.svg';

class WholesalerOverride extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: '',
            userdata: JSON.parse(localStorage.getItem('user')),
            loader: true,
            UserList: [],
            UserList_ut: [],
            overrides: [],
            btnLoader: false,
            overridesStatus: ''
        }
        this.add_override_row = this.add_override_row.bind(this);
        this.handleChange_overrides_user = this.handleChange_overrides_user.bind(this);
    }
    componentDidMount() {
        this.fetchOverrides(this.props.whEmail, parseInt(this.props.whId), this.props.whName);
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
    }
    fetchOverrides(whname, wholesaler_Id, mname) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ whname, wholesaler_Id, mname })
            };
            return fetch(`/api/admin/Wh_Overrides_Users`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        let randomId = Math.floor(10000 + Math.random() * 90000);
                        if (apidata.length > 0) {
                            if (apidata[0]["all_Overrides"].length > 0) {
                                this.setState({ UserList: apidata[0]["all_Overrides"], loader: false, error: '', UserList_ut: apidata[0]["all_Overrides"] });
                            } else {
                                this.setState({ loader: false, error: 'Error, Try Again' });
                            }
                            if (apidata[0]["user_Overrides"].length > 0) {
                                let userOverrides = apidata[0]["user_Overrides"];
                                userOverrides.forEach((obj) => {
                                    obj.id = randomId;
                                    if (obj.whName == '') {
                                        obj.editable = true
                                    } else {
                                        obj.editable = false
                                    }
                                });
                                this.setState({ overrides: userOverrides, loader: false, error: '', overridesStatus: 'edit overrides' });
                            } else {
                                if (this.state.overrides.length == 0) {
                                    let rowdata = { whId: "", whName: "", commission: "", emailId: "", editable: true, id: randomId };
                                    this.setState({ loader: false, overrides: this.state.overrides.concat(rowdata), overridesStatus: 'save overrides' })
                                }
                            }
                        } else {
                            this.setState({ loader: false, error: 'Opps!, Something went wrong. Try Again.' });
                        }
                    }
                    catch (error) {
                        this.setState({ loader: false, error: 'Opps!, Something went wrong. Try Again.' });
                    }
                });
        }
        catch (error) {
            this.setState({ loader: false, error: 'Opps!, Something went wrong. Try Again.' });
        }
    }
    fetchOverrides_update(whname, wholesaler_Id, mname) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ whname, wholesaler_Id, mname })
            };
            return fetch(`/api/admin/Wh_Overrides_Users`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0]["all_Overrides"].length > 0) {
                                this.setState({ UserList: apidata[0]["all_Overrides"], loader: false, UserList_ut: apidata[0]["all_Overrides"] });
                            } else {
                                this.setState({ loader: false, error: 'Error, Try Again' });
                            }
                        }
                    }
                    catch (error) {
                        this.setState({ loader: false, error: 'Opps!, Something went wrong. Try Again.' });
                    }
                });
        }
        catch (error) {
            this.setState({ loader: false, error: 'Opps!, Something went wrong. Try Again.' });
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    handleChange_overrides_user(e) {
        try {
            // get values
            let overrideData = this.state.overrides;
            let wholesalerName = $(e.target).attr('whName');
            let wholesalerEmail = $(e.target).attr('whEmail');
            let wholesalerCommission = $(e.target).attr('whCommission');
            let wholesalerId = $(e.target).attr('whId');
            let rowIndex = $(e.target).attr('whIndex');
            
            // assign values
            e.target.parentElement.parentElement.children[0].value = wholesalerName;
            e.target.parentElement.parentElement.parentElement.nextElementSibling.children[0].children[0].value = wholesalerEmail;
            e.target.parentElement.parentElement.parentElement.nextElementSibling.nextElementSibling.children[0].children[0].value = wholesalerCommission;
            $(e.target).parents().removeClass('open');
            e.target.parentElement.parentElement.parentElement.nextElementSibling.nextElementSibling.children[0].children[2].value = wholesalerId;

            // assign values
            e.target.parentElement.nextSibling.textContent = wholesalerName;
            e.target.parentElement.parentElement.parentElement.nextElementSibling.children[0].children[0].nextSibling.textContent = wholesalerEmail;
            e.target.parentElement.parentElement.parentElement.nextElementSibling.nextElementSibling.children[0].children[0].nextSibling.textContent = wholesalerCommission;

            // logic for cancel row taking another row data issue
            overrideData[rowIndex].whId = wholesalerId;
            overrideData[rowIndex].whName = wholesalerName;
            overrideData[rowIndex].emailId = wholesalerEmail;
            overrideData[rowIndex].commission = wholesalerCommission;
            overrideData[rowIndex].editable = true;
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    add_override_row(event) {
        let randomId = Math.floor(10000 + Math.random() * 90000);
        try {
            let rowdata = { override: '', whId: "", whName: "", commission: "", emailId: "", editable: true, id: randomId};
            this.setState({ overrides: this.state.overrides.concat(rowdata) });
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    handleClose = () => {
        try {
            this.props.closeOverridePopup(this.props.whName, this.props.whId, this.props.whPrefix, this.props.whProfilePagin, this.props.whSearch);
            this.props.openEditProfilePopup(this.props.whName, this.props.whId, this.props.whPrefix, this.props.whProfilePagin, this.props.whSearch);
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    cancelList = (e) => {
        try {
            let currentIndex = e.target.parentElement.parentElement.getAttribute("dataIndex");
            let listData = this.state.overrides;
            listData.splice(currentIndex, 1);
            this.setState({ overrides: listData });
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    saveData = (e) => {
        try {
            // get input field values
            let name = e.target.parentElement.parentElement.children[0].children[0].children[0].value;
            let email = e.target.parentElement.parentElement.children[1].children[0].children[0].value;
            let commission = e.target.parentElement.parentElement.children[2].children[0].children[0].value;
            let currentIndex = e.target.parentElement.parentElement.getAttribute("dataIndex");
            var parentId = e.target.parentElement.parentElement.children[2].children[0].children[2].value;
            if (!userService.Check_Null_Empty(name) && !userService.Check_Null_Empty(email) && !userService.Check_Null_Empty(commission) && userService.validateCurrency(commission)) {
                if (!userService.ValidateEmail(email)) {
                    this.setState({ error: 'Enter a valid email ID', loader: false });
                } else if (commission > 10) {
                    this.setState({ error: 'Commission should not be more than 10', loader: false });
                } else {
                    e.target.parentElement.parentElement.classList.remove("ineditable");
                    let overrideData = this.state.overrides;
                    overrideData.splice(currentIndex, 1, { whId: parentId, whName: name, commission: commission, emailId: email, IsSave: true });
                    this.setState({ error: '', overrides: overrideData });
                }
            } else {
                this.setState({ error: "Fields can't be blank and commission should be a numeric value e.g. 0.10" });
            }
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    handleEdit = (e) => {
        try {
            e.target.parentElement.parentElement.classList.add("ineditable");
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    showList = (e) => {
        try {
            e.target.nextElementSibling.classList.add('open');
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    hideList = (e) => {
        try {
            setTimeout(() => {
                $('.first-one ul').removeClass('open');
            }, 500);
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    keyPress = (e) => {
        try {
            if (e.target.value.length > 0) {
                e.target.nextElementSibling.classList.add('open');
                var li = e.target.nextElementSibling.children;
                try {
                    var filterElement = this.state.UserList.filter(function (item, i) {
                        if (item.whName.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1) {
                            li[i].style.display = "block";
                        }
                        else {
                            li[i].style.display = "none";
                        }
                    })
                }
                catch (error) {
                    var filterElement = this.state.UserList_ut.filter(function (item, i) {
                        if (item.whName.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1) {
                            li[i].style.display = "block";
                        }
                        else {
                            li[i].style.display = "none";
                        }
                    })
                }
            }
            else {
                e.target.nextElementSibling.classList.remove('open');
            }
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    validateCommission = (e) => {
        try {
            var iKeyCode = (e.which) ? e.which : e.keyCode
            if (iKeyCode != 46 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57)) {
                this.setState({ error: "Commission should be a numeric value e.g. 0.10" });
                return false;
            } else {
                return true;
            }
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    handleSaveSubmit = (e) => {
        let error_set = 0;
        this.setState({ btnLoader: true });
        try {
            let wh_Parent_Id = this.props.whId;
            if ($(".milestoneData").hasClass("ineditable")) {
                error_set += 1;
                this.setState({ error: 'Please enter overrides details in row else can remove row', btnLoader: false });
            } else {
                let overrideData = this.state.overrides;
                let override_table = [];
                for (let i = 0; i < overrideData.length; i++) {
                    let wh_Override_Id = overrideData[i].whId;
                    let wh_commission = overrideData[i].commission;
                    if (wh_Override_Id == null || wh_Override_Id == undefined || wh_Override_Id == '') {
                        error_set += 1;
                        this.setState({ error: 'Need to fill details for generated rows else can remove row.', btnLoader: false });
                        break;
                    }
                    if (override_table.length > 0) {
                        var newArray = override_table.filter(function (el) {
                            return el.wh_Override_Id == wh_Override_Id;
                        });
                        if (newArray.length > 0) {
                            error_set += 1;
                            this.setState({ error: 'Duplicate overrides has been added. Please remove duplicate users.', btnLoader: false });
                            break;
                        }
                        else {
                            override_table.push({ 'wh_Parent_Id': wh_Parent_Id, 'wh_Override_Id': wh_Override_Id, 'wh_commission': wh_commission });
                        }
                    }
                    else {
                        override_table.push({ 'wh_Parent_Id': wh_Parent_Id, 'wh_Override_Id': wh_Override_Id, 'wh_commission': wh_commission });
                    }
                }
                if (error_set == 0) {
                    let Override_Json = JSON.stringify(override_table);
                    if (Override_Json == '[]') {
                        override_table.push({ 'wh_Parent_Id': wh_Parent_Id, 'wh_Override_Id': 0, 'wh_commission': 0 });
                        Override_Json = JSON.stringify(override_table);
                    }
                    this.saveOverrides(this.state.userdata.username, this.state.userdata.userrole, this.state.userdata.id, this.state.userdata.email, this.state.overridesStatus, Override_Json, this.props.whId);
                }
            }
        }
        catch (error) {
            this.setState({ error: 'Error, Try again', btnLoader: false });
        }
    }
    saveOverrides(roleName, roleType, id, email, action, generatedJson, wholesaler_id) {
        $(".button-section .save").attr("disabled", "true");
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'whOverrides': generatedJson },
                body: JSON.stringify({ roleName, roleType, id, email, action, wholesaler_id })
            };
            return fetch(`/api/admin/Process_Wh_Override`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].status_code == "1") {
                                this.setState({ UserList: apidata, btnLoader: false, loader: false, error: apidata[0].status_message });
                                $(".button-section .save").removeAttr("disabled");
                                setTimeout(() => {
                                    this.handleClose();
                                }, 2000);
                            } else {
                                this.setState({ btnLoader: false, loader: false, error: apidata[0].status_message });
                                $(".button-section .save").removeAttr("disabled");
                            }
                        } else {
                            this.setState({ loader: false, error: 'Opps!, Something went wrong. Try Again.', btnLoader: false });
                            $(".button-section .save").removeAttr("disabled");
                        }
                    }
                    catch (error) {
                        this.setState({ loader: false, error: 'Opps!, Something went wrong. Try Again.', btnLoader: false });
                        $(".button-section .save").removeAttr("disabled");
                    }
                    this.fetchOverrides_update(this.props.whEmail, parseInt(this.props.whId), this.props.whName);
                });
        }
        catch (error) {
            this.setState({ loader: false, error: 'Opps!, Something went wrong. Try Again.', btnLoader: false });
            $(".button-section .save").removeAttr("disabled");
        }
    }
    handlecancel = (e) => {
        try {
            // get input field values
            let overrideData = this.state.overrides;
            let name = e.target.parentElement.parentElement.children[0].children[0].children[0].value;
            let email = e.target.parentElement.parentElement.children[1].children[0].children[0].value;
            let commission = e.target.parentElement.parentElement.children[2].children[0].children[0].value;
            let currentIndex = e.target.parentElement.parentElement.getAttribute('dataindex');

            if (!userService.Check_Null_Empty(name) && !userService.Check_Null_Empty(email) && !userService.Check_Null_Empty(commission) && userService.validateCurrency(commission)) {
                if (overrideData[currentIndex].editable == true) {
                    overrideData.splice(currentIndex, 1);
                    this.setState({ error: '', overrides: overrideData });
                } else {
                    e.target.parentElement.parentElement.classList.remove("ineditable");
                    this.setState({ error: '' });
                }
            } else if (overrideData[currentIndex].IsSave == true || overrideData[currentIndex].editable == false) {
                if (userService.Check_Null_Empty(name) && userService.Check_Null_Empty(email) && userService.Check_Null_Empty(commission)) {
                    overrideData.splice(currentIndex, 1);
                    this.setState({ error: '', overrides: overrideData });
                } else {
                    e.target.parentElement.parentElement.children[0].children[0].children[0].value = overrideData[currentIndex].whName;
                    e.target.parentElement.parentElement.children[2].children[0].children[0].value = overrideData[currentIndex].commission;
                    e.target.parentElement.parentElement.classList.remove("ineditable");
                    this.setState({ error: '' });
                }
            } else {
                overrideData.splice(currentIndex, 1);
                this.setState({ error: '', overrides: overrideData });
            }
        }
        catch (error) {
            this.setState({ error: 'Error, Try again', btnLoader: false });
        }
    }
    render() {
        const { loader, error, overrides, UserList, btnLoader } = this.state;
        let disabled = false;
        disabled = this.state.loader ? true : false;
        return (
            <div className='popup mfp-zoom-in override-content admin-popup whOverride-popup'>
                <div className='popup_inner manage-distributor-design'>
                    {loader &&
                        <div className="theme-loader"></div>
                    }

                    <h1>{this.props.text}<button onClick={this.handleClose}>X </button></h1>

                    <div className="wholesaler-section">
                        <form className="add-wh-form">
                            <div className="login-hub-section">

                                <div className="override-section milestone differ">
                                    <div className="right">
                                        <h2 className="adding-override">Override</h2>
                                        <a href="javascript:void('0')" id="lastChance" className="add-new" onClick={disabled ? null : this.add_override_row}>Add New Override</a>
                                        {
                                            overrides != null && overrides.length > 0 ?
                                                <table className="override-added">
                                                    <thead>
                                                        <tr className="header Sub">
                                                            <th className="first-one">Name</th>
                                                            <th className="second-one">Email</th>
                                                            <th className="third-one">Commission</th>
                                                            <th className="fourth-one">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            overrides.map((grouprow, index) =>
                                                                <tr className={grouprow.editable ? "milestoneData ineditable" : "milestoneData"} dataIndex={index}>
                                                                    <td className="first-one">
                                                                        <div className="formgroup" key={grouprow.id}>
                                                                            <input type="text" defaultValue={grouprow.whName} autoComplete={'' + Math.random()} onFocus={this.showList} onBlur={this.hideList} className="namefield_ form-control" name="overrides_name" onKeyUp={this.keyPress} />
                                                                            <ul>
                                                                                {UserList.map(item => <li whId={item.whId} whName={item.whName} whEmail={item.emailId} whIndex={index} whCommission={item.commission} key={item.whName + "__" + 1} onClick={this.handleChange_overrides_user.bind(this)}>{item.whName}</li>)}
                                                                            </ul>
                                                                            <span>{grouprow.whName}</span>
                                                                        </div>
                                                                    </td>
                                                                    <td className="second-one">
                                                                        <div className="formgroup" key={grouprow.id}>
                                                                            <input disabled defaultValue={grouprow.emailId} type="email" required className="form-control" name="email" />
                                                                            <span>{grouprow.emailId}</span>
                                                                        </div>
                                                                    </td>
                                                                    <td className="third-one">
                                                                        <div className="formgroup" key={grouprow.id}>
                                                                            <input onKeyUp={this.validateCommission} defaultValue={grouprow.commission} type="text" className="form-control" name="commission" />
                                                                            <span>{grouprow.commission}</span>
                                                                            <input type="text" className="form-control defaultInput" defaultValue={grouprow.whId} name="Id" />
                                                                        </div>
                                                                    </td>
                                                                    <td className="fourth-one">
                                                                        <input type="button" className="btn save" onClick={this.saveData} value="Save" />
                                                                        <input type="button" onClick={this.handlecancel} className="btn cancel" value="Cancel" />
                                                                        <img src={EditIcon} onClick={this.handleEdit} className="editIcon" alt="editIcon" />
                                                                        <img src={DeleteIcon} onClick={this.cancelList} className="deleteIcon" alt="deleteIcon" />
                                                                    </td>
                                                                </tr>
                                                            )}
                                                    </tbody>
                                                </table>
                                                : <span className="no-override-added">No Overrides added yet</span>
                                        }
                                    </div>
                                </div>

                                <div className="button-section">
                                    {btnLoader &&
                                        <div className="theme-loader animated-loader"></div>
                                    }
                                    <input disabled={disabled} type="button" onClick={this.handleSaveSubmit} className={btnLoader ? 'btn save animated-btn' : 'btn save'} value="Save & Submit" />
                                    <input disabled={disabled} type="button" onClick={this.handleClose} className="btn cancel" value="Cancel" />
                                    {error &&
                                        <div className={'alert alert-danger'}>{error}</div>
                                    }
                                </div>
                            </div>
                        </form>
                    </div>




                </div>
            </div>
        )
    }
}
export default WholesalerOverride;